import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import { createConsent, updateConsent } from '~/states/modules/consent';

import { onClose } from '~/common/closeMessage';
import { useStyle } from '~/common/style';

import Template from './Template';

const Home = () => {
	const dispatch = useDispatch();
	const company = useSelector(({ company }) => company.data);
	const cookies = useSelector(({ cookies }) => cookies.data);
	const consent = useSelector(({ consent }) => consent.data);
	const loading = useSelector(({ consent }) => consent.loading);
	const custom = useStyle();

	const [triggered, setTriggered] = useState(false);
	const [color, setColor] = useState(false);

	useEffect(() => {
		if (triggered && !loading && consent) {
			onClose();
			setTriggered(false);
		}
	}, [triggered, loading, consent]);

	const acceptAllCookies = () => {
		if (consent?.id && company?.id)
			dispatch(
				updateConsent({
					id: consent.id,
					companyId: company.id,
					consents: cookies,
				}),
			);
		else dispatch(createConsent({ companyId: company?.id, consents: cookies }));

		setTriggered(true);
	};

	const changeButtonColorOver = (event) => {
		setColor('#000000');
	};
	const changeButtonColorOut = (event) => {
		setColor(custom.cookiebarTxtColor);
	};

	return (
		<Template className="dl-cc-home">
			<div className="col">
				<Link
					to="/options"
					className="btn btn-outline-light btn-block d-flex justify-content-center"
					onMouseOver={changeButtonColorOver}
					onMouseOut={changeButtonColorOut}
					style={{ color: color || custom.cookiebarTxtColor }}
				>
					<span className="w-6 fs-text">Minhas Opções</span>
				</Link>
			</div>
			<div className="col">
				<button
					type="button"
					onClick={acceptAllCookies}
					className="btn btn-block d-flex justify-content-center"
					style={{
						backgroundColor: custom.cookiebarBtnColor,
						color: custom.cookiebarBtnTxtColor,
						border: null,
					}}
				>
					<span className="w-6 fs-text">{custom.cookiebarBtnTxt}</span>
				</button>
			</div>
		</Template>
	);
};

export default Home;
